import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getMtrStructApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'MTR_STRUCT_MAIN_CODE_ALREADY_EXISTS' || code === 'MTR_STRUCT_SUB_CODE_ALREADY_EXISTS') {
    return data?.message || '代號已存在';
  }

  if (code === 'MTR_STRUCT_MAIN_INACTIVE') {
    return data?.message || '主分類未啟用，無法建立子分類';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  return data?.message || fallback;
}

export function isMtrStructVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
